<template lang="pug">
#modal-compartilhamento-relatorio
    el-dialog.modal-compartilhamento-relatorio-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :before-close='fecharModal',
        width='537px'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.relatorioRastreabilidade.listagem.compartilharRelatorioRastreabilidade') }}

        .modal-compartilhamento-relatorio-conteudo
            .modal-compartilhamento-relatorio-conteudo-email
                .modal-compartilhamento-relatorio-conteudo-email-subtitulo__span
                    span.sub-tiulo {{ $t('mensagens.relatorioRastreabilidade.listagem.compartilharViaEmail') }}

                el-form(
                    ref='refFormCompartilhamento',
                    :model='formCompartilhamento',
                    :rules='regrasCompartilhamento',
                    @submit.native.prevent
                )
                    .modal-compartilhamento-relatorio-conteudo-email-envio
                        el-form-item(prop='email')
                            el-input.modal-compartilhamento-relatorio-conteudo-email-envio__input(
                                :placeholder='$t("mensagens.relatorioRastreabilidade.listagem.enderecoEmail")',
                                v-model='formCompartilhamento.email'
                            )

                        el-button.modal-compartilhamento-relatorio-conteudo-email-envio__button(
                            icon='mdi mdi-send',
                            @click='compartilharViaEmail',
                            type='primary'
                        ) {{ $t('mensagens.comuns.enviar') }}

            .modal-compartilhamento-relatorio-conteudo-separador
                span.center-span {{ $t('mensagens.relatorioRastreabilidade.listagem.ou') }}

            .modal-compartilhamento-relatorio-conteudo-link
                .modal-compartilhamento-relatorio-conteudo-link-subtitulo__span
                    span.sub-tiulo {{ $t('mensagens.relatorioRastreabilidade.listagem.compartilharLink') }}
                .modal-compartilhamento-relatorio-conteudo-link-envio
                    el-input.modal-compartilhamento-relatorio-conteudo-link-envio__input(
                        v-model='link',
                        readonly
                    )
                        template(
                            slot='suffix',
                            v-if='this.verificarClipboardDisponivel()'
                        )
                            .icone-link-compartilhar
                                i.el-icon-copy-document(
                                    style='cursor: pointer',
                                    @click='copiarLink'
                                )

                    el-button.modal-compartilhamento-relatorio-conteudo-link-envio__button(
                        icon='mdi mdi-whatsapp',
                        @click='compartilharViaWhatsapp',
                        type='primary'
                    )
</template>

<script>
export default {
    name: 'ModalCompartilhamentoRelatorio',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        link: {
            type: String,
            required: true
        },
        relatorioId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            formCompartilhamento: {
                email: ''
            },
            regrasCompartilhamento: {
                email: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.relatorioRastreabilidade.listagem.informeUmEmail'
                        ),
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: this.$t(
                            'mensagens.relatorioRastreabilidade.listagem.informeUmEmailValido'
                        ),
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },

    watch: {
        '$i18n._vm.locale': function () {
            this.updateRegrasCompartilhamento();
        }
    },

    methods: {
        fecharModal(done) {
            this.formCompartilhamento.email = '';
            this.$emit('voltar');
        },
        compartilharViaEmail() {
            this.$refs['refFormCompartilhamento'].validate(valid => {
                if (valid) {
                    this.$emit('enviarEmail', this.formCompartilhamento.email);
                } else {
                    return false;
                }
            });
        },
        compartilharViaWhatsapp() {
            const linkCompartilhado =
                'https://api.whatsapp.com/send?text=' +
                encodeURIComponent(this.link);

            window.open(linkCompartilhado, '_blank');
        },
        copiarLink() {
            if (this.verificarClipboardDisponivel()) {
                try {
                    navigator.clipboard.writeText(this.link);
                    this.$message.success(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.listagem.linkCopiado'
                        )
                    );
                } catch (err) {
                    this.$message.error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.listagem.naoFoiPossivelCopiarLink'
                        )
                    );
                }
            } else {
                this.$message.error(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.listagem.clipboardNaoDisponivel'
                    )
                );
            }
        },
        verificarClipboardDisponivel() {
            if (typeof navigator !== 'undefined' && 'clipboard' in navigator) {
                return true;
            } else {
                return false;
            }
        },
        updateRegrasCompartilhamento() {
            this.regrasCompartilhamento.email[0].message = this.$t(
                'mensagens.relatorioRastreabilidade.listagem.informeUmEmail'
            );
            this.regrasCompartilhamento.email[1].message = this.$t(
                'mensagens.relatorioRastreabilidade.listagem.informeUmEmailValido'
            );
        }
    }
};
</script>

<style lang="scss">
#modal-compartilhamento-relatorio {
    .modal-compartilhamento-relatorio-content {
        .el-dialog__header {
            padding: 20px;
            padding-bottom: 10px;
            padding-bottom: 12px;
            padding-top: 12px;
        }
        .el-dialog__headerbtn {
            top: 10px;
        }
        .el-dialog__headerbtn:hover .el-icon-close {
            color: #ffffff;
        }
        .modal-analise-elegibilidade--header {
            display: flex;
            align-items: center;
        }

        .sub-tiulo {
            font-weight: bold;
            color: var(--primary);
        }

        .modal-compartilhamento-relatorio-conteudo {
            display: flex;
            flex-direction: column;
            gap: 16px;

            .modal-compartilhamento-relatorio-conteudo-email,
            .modal-compartilhamento-relatorio-conteudo-link {
                display: flex;
                flex-direction: column;
                gap: 8px;

                .modal-compartilhamento-relatorio-conteudo-email-envio,
                .modal-compartilhamento-relatorio-conteudo-link-envio {
                    display: flex;
                    justify-content: space-between;
                    gap: 15px;

                    .icone-link-compartilhar {
                        height: 100%;
                        display: flex;
                        align-items: center;
                        padding-right: 3px;
                    }

                    .el-input__inner {
                        color: #595858 !important;
                    }
                }
            }

            .modal-compartilhamento-relatorio-conteudo-separador {
                color: #cccccc;
                display: flex;
                justify-content: center;
                position: relative;

                .center-span::before,
                .center-span::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    width: 45%;
                    border-bottom: 2.3px solid #cccccc;
                }

                .center-span::before {
                    left: -5px;
                }

                .center-span::after {
                    right: -5px;
                }
            }
        }

        button.el-button.modal-compartilhamento-relatorio-conteudo-link-envio__button.el-button--primary {
            background-color: #24d366;
            border-color: #24d366;
            color: var(--white);
        }
        button.el-button.modal-compartilhamento-relatorio-conteudo-email-envio__button {
            height: 40px;
        }
    }

    i.mdi.mdi-send {
        margin-right: 7px;
    }
    .el-form-item {
        width: 100%;
    }
}
</style>
